/** @file Bottom of a tree panel: its delete confirmation and the outcome of its last command. */
import type { Doc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { DeleteDialog } from './DeleteDialog';
import { FormStatus } from './FormStatus';
import type { TreePanel } from './useTreePanel';

/** Shared by Hierarchy and Assets so the two panels keep one copy of this wiring. */
export function TreePanelFooter({ doc, panel, t }: { doc: Doc; panel: TreePanel; t: Translate }) {
  return (
    <>
      <DeleteDialog doc={doc} targets={panel.deleting} t={t} onClose={() => { panel.setDeleting(null); }} onDone={panel.setStatus} />
      <FormStatus status={panel.status} t={t} />
    </>
  );
}
